import type { FC, SVGProps } from "react";

const IconFreeMinibar: FC<SVGProps<SVGSVGElement>> = (props) => (
	<svg viewBox="0 0 16 22" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="currentColor" {...props}>
    <path d="M1 5C1 3.93913 1.42143 2.92172 2.17157 2.17157C2.92172 1.42143 3.93913 1 5 1H11C12.0609 1 13.0783 1.42143 13.8284 2.17157C14.5786 2.92172 15 3.93913 15 5V19C15 19.5304 14.7893 20.0391 14.4142 20.4142C14.0391 20.7893 13.5304 21 13 21H3C2.46957 21 1.96086 20.7893 1.58579 20.4142C1.21071 20.0391 1 19.5304 1 19V5Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M1 9H15" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M11 6V12" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
);

export default IconFreeMinibar;